import { TagSeverityType } from "@chr/eds-react";
import { RiskLevelType } from "../constants/booking-types";

interface RiskLevelModel {
  type: RiskLevelType;
  label: string;
  color: string;
  severity: TagSeverityType;
}

const riskLevels: Record<string, RiskLevelModel> = Object.freeze({
  ['On Time']: {
    type: RiskLevelType.OnTime,
    label: 'On Time',
    color: 'success.main',
    severity: 'positive',
  },
  ['At Risk']: {
    type: RiskLevelType.AtRisk,
    label: 'At Risk',
    color: 'warning.main',
    severity: 'risky',
  },
  Late: {
    type: RiskLevelType.Late,
    label: 'Late',
    color: 'error.main',
    severity: 'negative',
  },
  Early: {
    type: RiskLevelType.Early,
    label: 'Early',
    color: 'early.main',
    severity: 'urgent',
  },
  Unassigned: {
    type: RiskLevelType.Unassigned,
    label: 'Unassigned',
    color: 'grey.400',
    severity: 'neutral',
  },
});

export const getRiskLevel = (type: string) => riskLevels[type] ?? riskLevels['Unassigned'];
